import TimeAgo from 'javascript-time-ago'
import de from 'javascript-time-ago/locale/de.json'
import en from 'javascript-time-ago/locale/en.json'
import es from 'javascript-time-ago/locale/es.json'
import fr from 'javascript-time-ago/locale/fr.json'
import it from 'javascript-time-ago/locale/it.json'
import ja from 'javascript-time-ago/locale/ja.json'
import pt from 'javascript-time-ago/locale/pt.json'
import zh from 'javascript-time-ago/locale/zh.json'

const timeAgoLocales = (locale: string): void => {
	switch (locale) {
		case 'de-DE':
			TimeAgo.addLocale(de)
			break
		case 'es-ES':
			TimeAgo.addLocale(es)
			break
		case 'fr-FR':
			TimeAgo.addLocale(fr)
			break
		case 'it-IT':
			TimeAgo.addLocale(it)
			break
		case 'pt-PT':
			TimeAgo.addLocale(pt)
			break
		case 'ja-JP':
			TimeAgo.addLocale(ja)
			break
		case 'zh-CN':
			TimeAgo.addLocale(zh)
			break
		case 'en-GB':
		case 'en-US':
		default:
			TimeAgo.addLocale(en)
	}
}

export default timeAgoLocales
